<template>
  <div>
      <main-header></main-header>
      <div class="pagebanner1" :style="{background:'url('+ banner.img +') center 0 no-repeat'}">
        <div>{{banner.title}}</div>
      </div>
      <div class="aboutus">
        <div class="w1200 aboutusbox">
          <div class="pic">
            <img :src="about.img" alt="">
          </div>
          <div class="cont">
            <h1>{{about.title}}</h1>
            <span v-html="about.content"></span>
          </div>
        </div>
      </div>
      <div class="team">
        <div class="title">
          <h1>{{team.title}}</h1>
          <span>{{team.subtitle}}</span>
        </div>
        <div class="swiper-container">
            <ul class="swiper-wrapper">
                <li v-for="(team,index) in team.teams" :key="index" :class="team.class">
                    <div class="nohover">
                        <img :src="team.image">
                    </div>
                    <div class="hover">
                        <div>
                          <img :src="team.image">
                        </div>
                        <span class="sp1">{{team.title}}</span>
                        <span class="sp2">{{team.work}}</span>
                    </div>
                </li>
              </ul>
            <div class="swiper-button-preva" @click="teamleft"></div>
            <div class="swiper-button-nexta" @click="teamright"></div>
        </div>
      </div>
      <div class="friend">
        <div class="w1200">
          <div class="title">
            <h1>{{partnera.title}}</h1>
            <span>{{partnera.subtitle}}
            </span>
          </div>
          <ul class="friendlist">
            <li v-for="(partner,index) in partners" :key="index">
              <a :href="partner.url === '' ? 'javascript:;' : partner.url" :target="partner.url === '' ? '_self' : '_blank'">
                <img :src="partner.image" alt="">
                <div class="block">
                  {{partner.title}}
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
  </div>
</template>

<script>
import MainHeader from './header'
import Fetch from '../js/ajaxa'
export default {
  name: 'about',
  data () {
    return {
      banner: {
        img: '',
        title: ''
      },
      about: {
        img: '',
        title: '',
        content: ''
      },
      team: {
        title: '',
        subtitle: '',
        teams: []
      },
      teamindex: 0,
      partnera: {
        title: '',
        subtitle: ''
      },
      partners: []
    }
  },
  methods: {
    scrollwrap: function (num) {
      var that = this
      var index = 0
      for (var j = 0; j < that.team.teams.length; j++) {
        that.team.teams[j].class = ''
      }
      for (var i = num - 3; i <= num + 3; i++) {
        index++
        if (i < 0) {
          that.team.teams[i + that.team.teams.length].class = 'ishover' + index
        } else if (i > that.team.teams.length - 1) {
          that.team.teams[i - that.team.teams.length].class = 'ishover' + index
        } else {
          that.team.teams[i].class = 'ishover' + index
        }
      }
    },
    teamleft: function () {
      var that = this
      this.teamindex--
      if (this.teamindex < 0) {
        this.teamindex = that.team.teams.length - 1
      }
      this.scrollwrap(this.teamindex)
    },
    teamright: function () {
      var that = this
      this.teamindex++
      if (this.teamindex > that.team.teams.length - 1) {
        this.teamindex = 0
      }
      this.scrollwrap(this.teamindex)
    }
  },
  mounted () {
  },
  components: {
    MainHeader
  },
  beforeCreate () {
    const that = this
    Fetch.post('Api/about', {
    }).then((res) => {
      that.banner.img = res.about.banner
      that.banner.title = res.about.sub_title
      that.about.img = res.about.image
      that.about.title = res.about.title
      that.about.content = res.about.content
      that.team.title = res.about.team_title
      that.team.subtitle = res.about.team_sub_title
      that.partnera.title = res.about.partner_title
      that.partnera.subtitle = res.about.partner_sub_title
      that.partners = res.partner

      if (res.team.length < 2) {
        that.team.teams = res.team.concat(res.team)
        that.team.teams = that.team.teams.concat(that.team.teams)
        that.team.teams = that.team.teams.concat(that.team.teams)
        that.team.teams = JSON.parse(JSON.stringify(that.team.teams))
        that.scrollwrap(0)
      } else if (res.team.length < 4) {
        that.team.teams = res.team.concat(res.team)
        that.team.teams = that.team.teams.concat(that.team.teams)
        that.team.teams = JSON.parse(JSON.stringify(that.team.teams))
        that.scrollwrap(0)
      } else if (res.team.length < 7) {
        that.team.teams = res.team.concat(res.team)
        that.team.teams = JSON.parse(JSON.stringify(that.team.teams))
        that.scrollwrap(0)
      } else {
        that.team.teams = res.team
        that.scrollwrap(0)
      }
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .pagebanner1{height: 400px;overflow: hidden;display: flex;align-items: center;justify-content: center;font-size: 40px;color: #fff;}
  .aboutus{height: auto;padding: 100px 0;background-color: #fff;}
  .aboutusbox{display: flex;justify-content: space-between;}
  .aboutus .pic{width: 450px;height: 280px;}
  .aboutus .pic img{width: 450px;height: 280px;object-fit:cover;}
  .aboutus .cont{width: 670px;height: auto;overflow: hidden;}
  .aboutus .cont h1{display: block;line-height: 60px;height: 60px;margin-bottom: 25px;font-size: 40px;}
  .aboutus .cont span{display: block;line-height: 40px;font-size: 16px;line-height: 40px;color: #999;}
  .team{height: 600px;background-color: #F6F6F6;}
  .team .title{width: 100%;height: 160px;overflow: hidden;}
  .team .title h1{display: block;width: 100%;line-height: 48px;margin-top: 65px;text-align: center;font-size: 40px;color: #333;}
  .team .title span{display: block;width: 100%;line-height: 29px;margin-top: 18px;text-align: center;font-size: 16px;color: #999;}
  .swiper-container{width:100%;height: 500px;overflow: hidden;position: relative;}
  .swiper-wrapper{width: 100%;height: 500px;overflow: hidden;position: relative;}
  .swiper-wrapper li{width: 245px;height: 380px;display:none;position: absolute;top: 0;overflow: hidden;transition: 0.4s}
  .swiper-wrapper li .nohover{display: block;margin-top: 110px;width: 245px;height: 140px;display: flex;align-items: center;justify-content: center;position: relative;}
  .swiper-wrapper li .nohover::after{content: "";position: absolute;z-index: 1;width: 100%;height: 100%;background-color: rgba(0, 0, 0, 0.3);}
  .swiper-wrapper li .nohover img{max-width: 245px;max-height: 140px;width: auto;height: auto;}
  .swiper-wrapper li .hover{display: none;}
  .swiper-wrapper li .hover div{width: 560px;height: 278px;display: flex;align-items: center;justify-content: center;}
  .swiper-wrapper li .hover img{max-width: 560px;max-height: 278px;width: auto;height: auto;}
  .swiper-wrapper li .hover .sp1{display: block;width: 100%;height: 31px;line-height: 31px;text-align: center;font-size:18px;font-weight: bold;color: #000000;margin-top: 40px;}
  .swiper-wrapper li .hover .sp2{display: block;width: 100%;line-height: 28px;height: 28px;text-align: center;font-size: 16px;color: #000}
  .swiper-wrapper li .hover .sp3{display: block;width: 100%;line-height: 28px;height: 28px;text-align: center;font-size: 14px;color: #999999}
  .swiper-wrapper .ishover4 .nohover{display: none;}
  .swiper-wrapper .ishover4 .hover{display: block;}
  .swiper-wrapper .ishover3{left: 50%;margin-left: -555px;display: block;}
  .swiper-wrapper .ishover2{left: 50%;margin-left: -800px;display: block;}
  .swiper-wrapper .ishover1{left: 50%;margin-left: -1045px;display: block;}
  .swiper-wrapper .ishover4{width: 560px;height: 380px;position: absolute;left: 50%;margin-left: -280px;display: block;}
  .swiper-wrapper .ishover5{left: 50%;margin-left: 310px;display: block;}
  .swiper-wrapper .ishover6{left: 50%;margin-left: 555px;display: block;}
  .swiper-wrapper .ishover7{left: 50%;margin-left: 800px;display: block;}
  .swiper-button-preva{width: 27px;height: 50px;position: absolute;left: 50px;top:150px;background:url(../assets/indexleft.png) 0 0 no-repeat;cursor: pointer;z-index: 10;}
  .swiper-button-nexta{width: 27px;height: 50px;position: absolute;right: 50px;top: 150px;background:url(../assets/indexright.png) 0 0 no-repeat;cursor: pointer;z-index: 10;}
  .friend{height: 508px;}
  .swiper-wrapper{user-select:none;}
  .friend .title{width: 100%;height: 160px;overflow: hidden;}
  .friend .title h1{display: block;width: 100%;line-height: 48px;margin-top: 65px;text-align: center;font-size: 40px;color: #333;}
  .friend .title span{display: block;width: 100%;line-height: 29px;margin-top: 18px;text-align: center;font-size: 16px;color: #999;}
  .friendlist{width: 1215px;height: auto;margin-top: 23px;}
  .friendlist li{width: 190px;height: 100px;margin-right: 12px;margin-bottom: 10px;float: left;display: flex;align-items: center;justify-content: center;overflow: hidden;position: relative;}
  .friendlist li a{display: block;width: 100%;height: 100%;}
  .friendlist li img{width: 190px;height: 100px;object-fit:cover;}
  .friendlist li a .block{width: 100%;height: 100%;opacity: 0;position: absolute;top: 0;left: 0;background-color: rgba(0, 0, 0, 0.4);color: #fff;display: flex;align-items: center;justify-content: center;}
  .friendlist li a::before{
    content: '';
    position: absolute;
    bottom: 10px;
    top: 10px;
    left: 10px;
    right: 10px;
    z-index: 99;
    transition: all 0.35s;
    border-left: 1px solid #fff;
    border-right: 1px solid #fff;
    transform: scale(1, 0);
  }
  .friendlist li a::after{
    content: '';
    position: absolute;
    bottom: 10px;
    top: 10px;
    left: 10px;
    right: 10px;
    z-index: 99;
    transition: all 0.35s;
    border-top: 1px solid #fff;
    border-bottom: 1px solid #fff;
    transform: scale(0, 1);
  }
  .friendlist li a:hover .block{opacity: 1;}
  .friendlist li a:hover::before{
    transform: scale(1, 1);
  }
  .friendlist li a:hover::after{
    transform: scale(1, 1);
  }
</style>



// WEBPACK FOOTER //
// src/page/about.vue